var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsightsResendEmail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 4c.828 0 1.5.647 1.5 1.444v5.91h-1.5V8.526a521 521 0 0 1-3.28 2.487 15 15 0 0 0-.333.263c-.715.572-1.743 1.397-2.886 1.39-1.15.007-2.191-.83-2.896-1.396a15 15 0 0 0-.325-.257A531 531 0 0 1 5.5 8.526v5.585h5.967v1.445H5.5c-.828 0-1.5-.648-1.5-1.445V5.444C4 4.647 4.672 4 5.5 4zm-13 1.444h13v1.229a309 309 0 0 1-4.206 3.204q-.135.103-.308.243c-.562.452-1.384 1.112-1.985 1.102-.605.01-1.43-.653-1.992-1.105a15 15 0 0 0-.303-.24A315 315 0 0 1 5.5 6.673z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.273 13.63a3.56 3.56 0 0 0-1.265 1.903l1.214.023c.136-.513.33-.695.75-1.02a2.409 2.409 0 1 1-.226 3.618l-.807.813a3.555 3.555 0 1 0 .334-5.338Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.667 18.222 1.335-1.333h-3.113V20z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsightsResendEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/insights-resend-email.6bdfdad5.svg";